import { Component, type ErrorInfo, type ReactNode } from "react"

import { reportCrash } from "@/components/crashReport"

// Around every page: a crash while drawing it shows a way back instead of a blank page, and is reported. The links reload the
// app in full, so the broken page doesn't come back with it.
export default class CrashBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false }

  static getDerivedStateFromError() {
    return { crashed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportCrash(error, "page", info.componentStack ?? undefined)
  }

  render() {
    if (!this.state.crashed) return this.props.children
    return (
      <main className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-rail px-6 text-center text-ink">
        <h1 className="font-condensed text-3xl font-bold">Something went wrong</h1>
        <p className="max-w-sm text-[15px] text-ink-muted">This page broke on our side. We've been told and will fix it.</p>
        <div className="flex gap-3">
          <a href="/daily" className="rounded-lg bg-brass px-5 py-2.5 font-condensed text-lg font-bold text-rail">
            Go to the daily
          </a>
          <button type="button" onClick={() => window.location.reload()} className="rounded-lg border border-white/20 px-5 py-2.5 font-condensed text-lg font-bold">
            Try again
          </button>
        </div>
      </main>
    )
  }
}
